import { z } from "zod";
import { BladeCommonSchema } from "../../../types";
import { BackdropSchema } from "../../Backdrop";
import { BladeHeaderSchema } from "../../BladeHeader";
import { RichTextSchema } from "../../RichText";
import { generateContentGroupSchema } from "../../utils/helpers";
const GroupedRichTextSchema = generateContentGroupSchema(RichTextSchema);
export const GroupedRichTextBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    groups: z.array(GroupedRichTextSchema),
});
//# sourceMappingURL=index.js.map